<template>
  <v-app>
    <div class="text-right"
         style="direction: rtl">
      <v-main>
        <vue-page-transition>
          <router-view>
          </router-view>
        </vue-page-transition>
      </v-main>

      <!--      <v-fab-transition>
              <a href=" https://wa.me/+989124092258" target="_blank" id="whatsAppFab">
                <v-btn
                    class="black&#45;&#45;text mb-3 ml-3"
                    x-large
                    color="greenColor"
                    elevation="0"
                    fab
                    fixed
                    bottom
                    left
                >
                  <i class="fab fa-whatsapp contactUs-fab mb-1 ml-1"></i>
                </v-btn>
              </a>
            </v-fab-transition>
            <div class="row" v-if="isAutomation">
              <div class="col-md-10 mr-md-auto col-12 footer-position">
                <div class="text-center mb-2"> تمامی حقوق وبسایت محفوظ و در اختیار
                  <a href="https://digikia.net/" target="_blank"><span
                      class="footer-word"> iran zillow</span></a> می باشد.
                </div>
              </div>
            </div>-->
    </div>
  </v-app>
</template>
<script>


export default {
  name: 'App',
  data: () => ({

  }),
  mounted() {
    this.$convertFarsiNumber()
    if (window.location.href.toLowerCase().indexOf("automation") > -1) {
      this.isAutomation = true
    }

  }
};
</script>
